import { IRequestCourseModel } from 'models/requestCourse.model'
import { EnrolState } from 'enum/enrol-state.enum'
import api from '..'

export interface ResponseEditRequestCourse {
  data: IRequestCourseModel[]
}

type BaseParams = {
  name: string
  cost: string
  startDate: string
  endDate: string
  hour: number
  message?: string
  senceCode?: string
  state: EnrolState
  stateAdmin: EnrolState
  urlCourse: string
  answer?: string
  answerAdmin?: string
}

export type EditRequestCourseParams = { id: number } & Partial<BaseParams>

const editRequestCourse = ({ id, ...values }: EditRequestCourseParams) => {
  return api.patch(`outsides_courses/${id}`, {
    OutsidesCourse: values,
  })
}

export default editRequestCourse
